import React from 'react'

import styles from './load.module.css'

export const Load = ({message = '', color = 'var(--primary-color)', size = 100}) => {
    return <div style={{'--size': size + '%'}} className={styles.LoadWrapper}>
        <svg width='100%' height='100%' className={styles.Load} viewBox='0 0 100 100'>
            <circle style={{
                stroke: color
            }} cx='50' cy='50' r='40'></circle>
        </svg>
        {
            (message) ?
            <div className={styles.LoadMessage}>{message}</div>
            : ''
        }
    </div>
}